import { useEffect, useState } from "react"
import { EntryMode, PutCrossCountryEntry } from "../../../models/Admin/CountryTables"
import { CountryAutoComplete } from "../../../models/Autocomplete"
import msalRestClient from "../../../services/clients/MsalRestClient"

type CountryTableEntryProps = {

    index: number,
    value: PutCrossCountryEntry,

    /**
     * Callback method that gets executed when changes has been done.
     * @param entry
     * @param entryIndex
     * @returns
     */
    onConfirm: (entry: PutCrossCountryEntry, entryIndex: number) => void,

    /**
     * Callback method that gets executed when entry should be deleted.
     * @param entryIndex
     * @returns
     */
    onDelete: (entryIndex: number) => void
}

const CountryTableEntry = ({ index, value, onConfirm, onDelete }: CountryTableEntryProps) => {

    const [entry, setEntry]         = useState<PutCrossCountryEntry>(value);
    const [countries, setCountries] = useState<CountryAutoComplete[]>([]);

    useEffect(() => {
        /* Fetch Countries for automcomplete dropdowns */
        msalRestClient.get<CountryAutoComplete[]>("/api/countries/autocomplete")
            .then(response => {
                setCountries(response.data);
            })
    }, []);

    /**
     * Handles on Submit method for edit or create button click. 
     */
    const onSubmit = () => {

        /* TODO: Implement some kind of validation ... */
        entry.mode = EntryMode.Display;
        onConfirm(entry, index);
    }

    /**
     * Renders a JSX Element that represents a single button for handling different kind of states.
     * @returns: JSX Element
     */
    const renderButton = () => {

        switch (entry.mode) {
            case EntryMode.Display: return <><button className="btn btn-warning" onClick={e => setEntry(x => ({ ...x, mode: EntryMode.Edit }))}><i className="bi bi-pencil"></i></button> | <button className="btn btn-danger" onClick={e => onDelete(index)}><i className="bi bi-trash"></i></button></>
            case EntryMode.Edit:    return   <button className="btn btn-success" onClick={onSubmit}><i className="bi bi-check-lg"></i></button>
            case EntryMode.Create:  return   <button className="btn btn-success" onClick={onSubmit}><i className="bi bi-check-lg"></i></button>
        }
    }

    /**
     * Render JSX Element
     */
    return (
        <tr>
            <td>{entry.mode === EntryMode.Display ? (countries.find(x => x.value === entry.sourceCountryId)?.displayValue) : <select className="form-select" defaultValue={entry.sourceCountryId} onChange={e => setEntry(x => ({ ...x, sourceCountryId: Number(e.target.value) }))}>{countries.map((value, index2) => { return (<option key={index + "_" + index2} value={value.value}>{value.displayValue}</option>) })}</select>}</td>
            <td>{entry.mode === EntryMode.Display ? (countries.find(x => x.value === entry.targetCountryId)?.displayValue) : <select className="form-select" defaultValue={entry.targetCountryId} onChange={e => setEntry(x => ({ ...x, targetCountryId: Number(e.target.value) }))}>{countries.map((value, index2) => { return (<option key={index + "_" + index2} value={value.value}>{value.displayValue}</option>) })}</select>}</td>
            <td>{entry.mode === EntryMode.Display ? (entry.refundRate) + " EUR" : (<input type="number" onChange={e => setEntry(x => ({ ...x, refundRate: Number(e.target.value) }))} value={entry.refundRate} className="form-control"></input>)}</td>
            <td>{renderButton()}</td>
        </tr>
    )
}
export default CountryTableEntry;